// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import parse from 'html-react-parser';
import uuid from 'react-uuid';

// Components
import Container from '../../container/container';
import Image from '../../image/image';

// Styles
import BoxesStyles from './boxes.styles';

export default function Boxes({ layout, isFirstLayout }) {
  const boxes = layout?.boxes;
  const wideText = layout?.wideText;

  const bgColor = layout?.backgroundColour;

  return (
    <BoxesStyles wideText={wideText} bgColor={bgColor}>
      {layout?.heading && (
        <Container>
          <div className="heading-wrapper">
            {isFirstLayout ? (
              <h1 className="heading large">{layout?.heading}</h1>
            ) : (
              <h2 className="heading large">{layout?.heading}</h2>
            )}
          </div>
        </Container>
      )}
      <Container flex justifyContent="space-between">
        {boxes && (
          <>
            {boxes.map((box) => (
              <div className="box" key={uuid()}>
                {box?.image && (
                  <div className="top">
                    <Image image={box?.image} className="img" />
                  </div>
                )}
                <div className="bottom">
                  {box?.heading && <h3 className="heading">{box?.heading}</h3>}
                  {box?.subheading && (
                    <h4 className="subheading">{box?.subheading}</h4>
                  )}
                  {box?.text && <div className="text">{parse(box?.text)}</div>}
                  {box?.buttons && (
                    <div className="btn-group">
                      {box?.buttons.map((button) => (
                        <Link
                          key={button?.button?.title}
                          to={button?.button?.url}
                          className="btn no-shadow"
                        >
                          {button?.button?.title}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </>
        )}
      </Container>
    </BoxesStyles>
  );
}

Boxes.propTypes = {
  layout: PropTypes.shape({
    heading: PropTypes.string,
    backgroundColour: PropTypes.string,
    wideText: PropTypes.bool,
    boxes: PropTypes.arrayOf(
      PropTypes.shape({
        heading: PropTypes.string,
        text: PropTypes.string,
        buttons: PropTypes.arrayOf(PropTypes.shape({})),
        image: PropTypes.shape({
          altText: PropTypes.string,
          gatsbyImage: PropTypes.shape({}),
        }),
      }),
    ),
  }),
  isFirstLayout: PropTypes.bool,
};

Boxes.defaultProps = {
  layout: {},
  isFirstLayout: false,
};
